import DatePicker from 'vue2-datepicker';
import ptBr from 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import { POLICY_STATUSES } from '@/utils/constants';
import lifeApiService from '@/services/life-api';
import moment from 'moment';
import { DOCUMENT_MASK } from '../../../constants/cpfCnpj';

export default {
  name: 'MicroLifeReportFilter',
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      DOCUMENT_MASK,
      filters: {
        start_issue_date: null,
        end_issue_date: null,
        start_cancellation_date: null,
        end_cancellation_date: null,
        statuses: [],
        insured_cpf: null,
        insured_name: null,
        stipulator_id: [],
      },
      lang: ptBr,
      stipulatorOptions: [],
    };
  },
  mounted() {
    this.getStipulators();
  },
  computed: {
    policyStatusOptions() {
      return Object.keys(POLICY_STATUSES)
        .map((key) => {
          return {
            id: POLICY_STATUSES[key].id,
            label: POLICY_STATUSES[key].name,
          };
        })
        .filter((status) => status.id !== POLICY_STATUSES.OPEN.id);
    },
    canGenerateReport() {
      return (
        (this.filters.start_issue_date && this.filters.end_issue_date) ||
        (this.filters.start_cancellation_date &&
          this.filters.end_cancellation_date) ||
        this.filters.statuses.length > 0 ||
        this.filters.insured_cpf ||
        this.filters.insured_name ||
        this.filters.stipulator_id.length > 0
      );
    },
  },
  methods: {
    async exportReport() {
      if (!this.canGenerateReport) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Selecione pelo menos um filtro para gerar o relatório`,
          color: 'warning',
        });
        return;
      }
      const filters = {
        ...this.filters,
        start_issue_date: this.filters.start_issue_date
          ? moment(this.filters.start_issue_date, 'DD/MM/YYYY').toDate()
          : null,
        end_issue_date: this.filters.end_issue_date
          ? moment(this.filters.end_issue_date, 'DD/MM/YYYY').toDate()
          : null,
        start_cancellation_date: this.filters.start_cancellation_date
          ? moment(this.filters.start_cancellation_date, 'DD/MM/YYYY').toDate()
          : null,
        end_cancellation_date: this.filters.end_cancellation_date
          ? moment(this.filters.end_cancellation_date, 'DD/MM/YYYY').toDate()
          : null,
      };
      this.$emit('export', filters);
    },
    async clear() {
      this.filters = {
        start_issue_date: null,
        end_issue_date: null,
        start_cancellation_date: null,
        end_cancellation_date: null,
        status: [],
        insured_cpf: null,
        insured_name: null,
        stipulator_id: [],
      };
    },
    async getStipulators() {
      try {
        const response = await lifeApiService.getStipulators();
        this.stipulatorOptions = response.map((stipulator) => {
          return {
            id: stipulator.id,
            label: stipulator.name,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    moment.locale('pt-br');
  },
};
